const truncate = ({ string, limit, preventCutWord }) => {
  try {
    if (string.length <= limit) {
      return string;
    }

    const subString = string.substr(0, limit - 1);
    const ellipses = '&hellip;';

    return (
      (preventCutWord
        ? subString.substr(0, subString.lastIndexOf(' '))
        : subString) + ellipses
    );
  } catch (error) {
    return string;
  }
}; //truncate

const innerTextWithoutChild = ({ element }) => {
  try {
    let response = '';

    if (element) {
      let child = element.firstChild;
      const texts = [];

      while (child) {
        if (child.nodeType === 3 && child.data.trim()) {
          texts.push(child.data.trim());
        }
        child = child.nextSibling;
      }

      response = texts.join(' ');
    }

    return response;
  } catch (error) {
    return '';
  }
}; //innerTextWithoutChild

export { truncate, innerTextWithoutChild };
